<template>
  <van-row class="message-wrapper" :class="messagePosition" v-if="currentConversationType === TIM.TYPES.CONV_C2C && isGetResumesStatusType">
    <div class="col-1" v-if="showAvatar">
      <van-image
          round
          width="0.5rem"
          height="0.5rem"
          :src="avatar"
      />
    </div>
    <div class="col-2">
      <!-- 消息主体 -->
      <div class="content-wrapper">
        <text-element
            v-if="message.type === TIM.TYPES.MSG_TEXT"
            :isMine="isMine"
            :payload="message.payload"
            :message="message"
        />
        <image-element
            v-else-if="message.type === TIM.TYPES.MSG_IMAGE"
            :isMine="isMine"
            :payload="message.payload"
            :message="message"
        />
        <file-element
            v-else-if="message.type === TIM.TYPES.MSG_FILE"
            :isMine="isMine"
            :payload="message.payload"
            :message="message"
        />
        <face-element
            v-else-if="message.type === TIM.TYPES.MSG_FACE"
            :isMine="isMine"
            :payload="message.payload"
            :message="message"
        />
        <video-element
            v-else-if="message.type === TIM.TYPES.MSG_VIDEO"
            :isMine="isMine"
            :payload="message.payload"
            :message="message"
        />
        <custom-element
            v-else-if="message.type === TIM.TYPES.MSG_CUSTOM"
            :isMine="isMine"
            :payload="message.payload"
            :message="message"
        />
        <span v-else>暂未支持的消息类型：{{message.type}}</span>
<!--
        <text-element
            v-if="message.type === TIM.TYPES.MSG_TEXT"
            :isMine="isMine"
            :payload="message.payload"
            :message="message"
        />
        <span v-else>暂未支持的消息类型：{{message.type}}</span>-->
      </div>
      <message-footer v-if="showMessageHeader" :message="message" />
    </div>
    <div class="col-3">
      <!-- 消息状态 -->
      <message-status-icon v-if="isMine" :message="message" />
    </div>
  </van-row>
  <van-row v-else>
    <div v-if="message.payload.extension==='overtime'" style="text-align: center;">
      您与对方已超过十分钟未沟通，如已沟通结束请为对方做出评价。
    </div>
  </van-row>
</template>

<script>
import { mapState } from 'vuex'
import MessageStatusIcon from './message-status-icon.vue'
import MessageFooter from './message-footer'
import FileElement from './message-elements/file-element.vue'
import FaceElement from './message-elements/face-element.vue'
import ImageElement from './message-elements/image-element.vue'
import TextElement from './message-elements/text-element.vue'
import VideoElement from './message-elements/video-element.vue'
import CustomElement from './message-elements/custom-element.vue'

export default {
  name: 'MessageItem',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  components: {
    MessageFooter,
    MessageStatusIcon,
    FileElement,
    FaceElement,
    ImageElement,
    TextElement,
    VideoElement,
    CustomElement,
  },
  data() {
    return {
      renderDom: []
    }
  },
  computed: {
    ...mapState({
      currentConversation: state => state.conversation.currentConversation,
      currentUserProfile: state => state.user.currentUserProfile,

    }),
    // 是否显示头像，群提示消息不显示头像
    showAvatar() {
      if (this.currentConversation.type === 'C2C' && !this.message.isRevoked) { // C2C且没有撤回的消息
        return true
      } else if (this.currentConversation.type === 'GROUP' && !this.message.isRevoked) { // group且没有撤回的消息
        return this.message.type !== this.TIM.TYPES.MSG_GRP_TIP
      }
      return false
    },
    avatar() {
      if (this.currentConversation.type === 'C2C') {
        return this.message.avatar
      } else if (this.currentConversation.type === 'GROUP') {
        return this.isMine
          ? this.currentUserProfile.avatar
          : this.message.avatar
      } else {
        return ''
      }
    },
    currentConversationType() {
      return this.currentConversation.type
    },
    isMine() {
      // console.log(this.currentUserProfile, this.currentConversation);
      return this.message.flow === 'out'
    },
    messagePosition() {
      if (
              ['TIMGroupTipElem', 'TIMGroupSystemNoticeElem'].includes(
                      this.message.type
              )
      ) {
        return 'position-center'
      }
      if (this.message.isRevoked) { // 撤回消息
        return 'position-center'
      }
      if (this.isMine) {
        return 'position-right'
      } else {
        return 'position-left'
      }
    },
    showMessageHeader() {
      if (
              ['TIMGroupTipElem', 'TIMGroupSystemNoticeElem'].includes(
                      this.message.type
              )
      ) {
        return false
      }
      return !this.message.isRevoked

    },
    isGetResumesStatusType() {//是否是同意拒绝发送简历特别消息，如果是的话，就隐藏
      if (this.message.payload.extension==='get_resumes_id') {
        const data = JSON.parse(this.message.payload.data)
        if (data.status===1) {
          this.$store.commit('custom/setGetResumesIdOk',data.id)
        }else if (data.status===2) {
          this.$store.commit('custom/setGetResumesIdNo',data.id)
        }

        return false
      }else if (this.message.payload.extension==='end_chat') {
        this.$store.commit('custom/setEndTalkList',this.currentConversation.conversationID)
      }else if (this.message.payload.extension==='overtime'){
        return false;
      }
      return true
    },
  },
  methods: {
    showGroupMemberProfile(event) {
      this.tim
              .getGroupMemberProfile({
                groupID: this.message.to,
                userIDList: [this.message.from]
              })
              .then(({data: {memberList}}) => {
                if (memberList[0]) {
                  this.$bus.$emit('showMemberProfile', {event, member: memberList[0]})
                }
              })
    }
  }
}
</script>

<style lang="stylus" scoped>
.message-wrapper {
  margin: 20px 0 20px;
  display: flex;
  padding 5px
  .col-2 {
    .base {
      margin-top: 3px;
    }
    .content-wrapper{
      max-width: 20rem;
    }
  }
  &.position-left {
    .col-2 {
      align-items: flex-start;
      .content-wrapper{
        background-color: #FFFFFF;
        padding: 0.12rem .25rem;
        border-radius: 0.2rem;
        margin-left: 10px;
      }
    }
  }
  &.position-right {
    flex-direction: row-reverse;
    .col-2 {
      align-items: flex-end;
      .content-wrapper{
        background-color: #55eb72;
        padding: 0.12rem .25rem;
        border-radius: 0.5rem;
        margin-right: 10px;
      }
    }
  }
  &.position-center {
    justify-content: center;
  }
}
</style>
